/* Global imports. */
import React from "react";
import LinkWrapper from "../LinkWrapper";

interface Props {
  quote: string;
  attribute?: string;
  attributeLink?: string;
}

const RenderAttributeName = ( attribute?:String ) => attribute && attribute.trim() !== "" &&
        <div className="relative block font-serif pl-16 text-[16px] sm:text-xl leading-7 before:bg-[#000] before:h-[1px] before:left-0 before:top-[50%] before:absolute before:w-[48px]">{attribute}</div>

const RenderAttributeNameLink = ( attribute?:String, attributeLink?:String ) => attribute && attribute.trim() !== "" && attributeLink && attributeLink.trim() !== "" &&
<LinkWrapper
    url={attributeLink}
    text={RenderAttributeName( attribute )}
/>

const Quote = ({ quote, attribute, attributeLink }: Props) => (
  <blockquote className="relative flex flex-wrap justify-end clear-both pt-10 mt-5 mb-5 mr-4 sm:mr-14 sm:ml-4 sm:my-8 sm:ml-4">
    <h5 className="before:content-['\201C'] before:font-['georgia'] before:top-0 before:w-[100px] before:text-[#d9d9d9] before:text-[100px] before:h-[100px] before:left-0 before:absolute before:leading-[100px] w-full pt-2 pl-12 sm:pr-6 mb-4 text-[16px] leading-[24px] sm:text-[21px] sm:leading-[30px] font-normal after:h-[2px] after:left-[56px] after:absolute after:top-[24px] after:leading-[100px] after:bg-[#d9d9d9] after:w-[64px]">‘{quote}’</h5>
        { attributeLink ? RenderAttributeNameLink( attribute, attributeLink ) :
        RenderAttributeName( attribute )}
  </blockquote>
);

export default Quote;
